import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=5b3e6e14"
import script from "./Action.vue?vue&type=script&lang=ts"
export * from "./Action.vue?vue&type=script&lang=ts"
import style0 from "./Action.vue?vue&type=style&index=0&id=5b3e6e14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports